import Parse from "parse";

import { useState } from "react";

import { useGame } from "../header/GameContext";

//Compornts
import ButtonOnly from "../button/buttonOnly";
import InputText from "../inputText/inputText";
import SelectBox from "../selectBox/selectBox";

//CSS
import { saveToSheet } from "../../api/sheet";

import "./intro.css";

//IMG import
import gameTitleImg from "../../img/game/game_title.png";
import modleLogoImg from "../../img/common/logo_modle.png";

/* 🔑 keyCode 생성 */
const generateKeyCode = () =>
  (
    Date.now().toString(36) + Math.random().toString(36).substring(2, 8)
  ).toUpperCase();

function UserInfo({ userName, setUserName, onFinish, defaultPath }) {
  const { DB_TABLE, setPlayerName, setPlayerKeyCode } = useGame();

  const isUserName = userName?.trim().length > 0;
  const [isLoading, setIsLoading] = useState(false);

  const handleStart = async () => {
    if (!isUserName) {
      alert("이름(닉네임)을 입력하세요.");
      return;
    }

    setIsLoading(true);

    try {
      // 닉네임 중복 체크
      const GameUser = Parse.Object.extend(DB_TABLE);
      const query = new Parse.Query(GameUser);
      query.equalTo("user_name", userName.trim());
      const count = await query.count();

      // if (count > 0) {
      //   alert("중복된 닉네임입니다.\n다른 닉네임을 입력해주세요.");
      //   return;
      // }

      const keyCode = generateKeyCode();

      const user = new GameUser();
      user.set("access_stage", ["start"]);
      user.set("user_key", keyCode);
      user.set("user_name", userName);
      await user.save();

      localStorage.setItem("gameUserId", user.id);

      setPlayerKeyCode(keyCode);
      setPlayerName(userName);

      await saveToSheet({
        user_key: keyCode,
        user_name: userName,
        action: "appendToSheet_skzmalang_qr1",
      });

      onFinish?.({
        defaultPath,
        state: { DateVal: "intro1" },
      });
    } catch (e) {
      console.error(e);
      alert("저장 실패. 다시 시도해주세요.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <div className="intro_pop_box user-info">
        <div id="login-cont">
          <div className="login-intro">
            <p className="login-intro__title">키자니아</p>
            <div className="login-intro__subtitle">
              <img src={gameTitleImg} alt="" />
            </div>
            <p className="login-intro__description">
              귀여운 고양이 탐정과 함께
              <br />
              AI 비밀본부의 미션을 해결하세요!
            </p>
          </div>

          <div className="login-form">
            <InputText
              textClass="input02"
              textValue="이름(닉네임) 입력"
              handleName={userName}
              setHandleName={setUserName}
            />
            <ButtonOnly
              btnValue={
                isLoading ? (
                  <>
                    <span className="btn-spinner" />
                  </>
                ) : (
                  "게임시작"
                )
              }
              btnClass={`gameStartBtn mt16 ${isUserName ? "active" : ""}`}
              onFinish={handleStart}
              disabled={!isUserName || isLoading}
            />
          </div>

          <div className="login__modle-logo">
            <img src={modleLogoImg} alt="" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default UserInfo;
